import { createSlice } from "@reduxjs/toolkit";
import {
  getAddressList,
  addOrupdateAddress,
  deleteAddress,
  setDefaultAddress,
  getCustomerAddressById,
} from "../thunks/customerAddThunk";

const initialState = {
  isAddressLoading: false,
  addressList: [],
  addressId: "",
  selectedAddress: null,
};

const customerAddSlice = createSlice({
  name: "customerAddress",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAddressList.pending, (state) => {
        state.isAddressLoading = true;
      })
      .addCase(getAddressList.fulfilled, (state, action) => {
        state.isAddressLoading = false;
        state.addressList = action.payload?.data || [];

        const defaultAddress =
          action.payload?.data?.find((a) => a.is_default === 1) ||
          action.payload?.data?.[0];

        state.addressId = defaultAddress?.address_id || "";
      })
      .addCase(getAddressList.rejected, (state) => {
        state.isAddressLoading = false;
      })
      .addCase(addOrupdateAddress.pending, (state) => {
        state.isAddressLoading = true;
      })
      .addCase(addOrupdateAddress.fulfilled, (state, action) => {
        ((state.isAddressLoading = false), (state.action = action.payload));
      })
      .addCase(addOrupdateAddress.rejected, (state) => {
        state.isAddressLoading = false;
      })
      .addCase(deleteAddress.pending, (state) => {
        state.isAddressLoading = true;
      })
      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.isAddressLoading = false;
        state.action = action.payload;
      })
      .addCase(deleteAddress.rejected, (state) => {
        state.isAddressLoading = false;
      })
      .addCase(setDefaultAddress.pending, (state) => {
        state.isAddressLoading = true;
      })
      .addCase(setDefaultAddress.fulfilled, (state, action) => {
        state.isAddressLoading = false;
        state.action = action.payload;
      })
      .addCase(setDefaultAddress.rejected, (state) => {
        state.isAddressLoading = false;
      })
      .addCase(getCustomerAddressById.pending, (state) => {
        state.isAddressLoading = true;
      })
      .addCase(getCustomerAddressById.fulfilled, (state, action) => {
        state.isAddressLoading = false;
        state.selectedAddress = action.payload?.data || null;
      })
      .addCase(getCustomerAddressById.rejected, (state) => {
        state.isAddressLoading = false;
      });
  },
});

export default customerAddSlice.reducer;
